import React from "react";
import clsx from "clsx";
import { geoZonesStore } from "geoZones/_stores/geoZonesStore";
import { useTranslation } from "react-i18next";
import { usePropertiesStore } from "properties/listing/PropertiesPageContext";
import styles from "./_css/PropertiesCount.module.css";
import { observer } from "mobx-react";
import { MAP_OR_LIST_SELECTED, usePropertiesPageContext } from "properties/PropertiesPageContext";
import { reformatNumber } from "_common/_utils/alphaNumUtils";

const PropertiesCount = observer(() => {
    const propertiesStore = usePropertiesStore();
    const { mapOrListSelected } = usePropertiesPageContext();
    const listStore = propertiesStore.getListStore(propertiesStore.purpose);
    const { t } = useTranslation();
    const displayCountIfResultsOrNoGeozone = (!!listStore.count && listStore.count > 0) || !geoZonesStore.geoZone;
    if (!displayCountIfResultsOrNoGeozone) return null;
    const smallLabel = mapOrListSelected === MAP_OR_LIST_SELECTED.MAP;
    return (
        <div className={clsx("flex_row_center flexWrap_wrap", styles.textResult, { ["text_xsmall"]: smallLabel })}>
            <span className={"truncate"}>
                <span>
                    {listStore.count} {t("words.listings")}
                </span>
                <span className={"mh_5"}>/</span>
                <span>
                    {t("propertiesPage.listingUnitsMatched", {
                        count: reformatNumber(propertiesStore.countUnits),
                    })}
                </span>
            </span>
        </div>
    );
});

export default PropertiesCount;
